import { isNullOrEmpty } from '../../../utilities/stringUtil';
import {
  DELETE_FILE_FLAG,
  FACE_PICTURE_UPLOAD_STATUS,
} from '../../../utilities/constants';

/**
 * 社員・ゲスト画像アップロードパラメータ作成
 * Binaryデータを送信するためFormDataを使用する
 * https://developer.mozilla.org/ja/docs/Web/API/FormData/Using_FormData_Objects
 * @param {object}param:登録パラメーター
 * @return {object}searchParam:API通信用登録パラメーター
 * */
const createUpdateFaceImage = param => {
  let formData = new FormData();
  if (!isNullOrEmpty(param.userId)) {
    formData.append('user_id', param.userId);
  }
  if (!isNullOrEmpty(param.fieldSpotWorkerId)) {
    formData.append('field_spot_worker_id', param.fieldSpotWorkerId);
  }
  if (!isNullOrEmpty(param.imageBinary)) {
    formData.append('image', param.imageBinary);
  }
  if (param.uploadStatus === FACE_PICTURE_UPLOAD_STATUS.deleteFile.id) {
    formData.append('delete_flg', DELETE_FILE_FLAG.deleteFlag.id);
  } else {
    formData.append('delete_flg', DELETE_FILE_FLAG.notDeleteFlag.id);
  }

  // @TODO: 後々必要なパラメーターなので削除しない
  // formData.append('integration_service_id', null);
  return formData;
};

/**
 *
 * */
const FaceImageService = {
  createUpdateFaceImage,
};

export default FaceImageService;



// WEBPACK FOOTER //
// ./src/services/spotWorkers/faceImage/FaceImageService.js